module.exports = __webpack_public_path__ + "static/signup-0a10615c363df41f6cb411e1b92649b6.gif";